module.exports = __webpack_public_path__ + "static/media/project2.a443a23e.png";